import * as Videos from "@discovery/sonic-api-ng/lib/api/content/videos";
import * as Shows from "@discovery/sonic-api-ng/lib/api/content/shows";
import { compose } from "@discovery/prelude/lib/data/function";
import * as CQ from "@discovery/sonic-api-ng/lib/api/common/query";
import * as Q from "@discovery/sonic-api-ng/lib/query";
const PageQueryForVideos = (pageSize, pageNumber) => {
    return pageNumber
        ? Videos.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.Index.SIZE, pageSize), CQ.Page.page(CQ.Page.Index.NUMBER, pageNumber)))
        : Videos.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.Index.SIZE, pageSize)));
};
const DecoratorForVideos = (decoratorType) => {
    return Videos.Query.lenses.decorators.set(CQ.Decorators.decorators(decoratorType));
};
const DecoratorForShows = (type, decoratorType) => {
    switch (type) {
        case "type1":
            return Shows.Query.lenses.decorators.set(CQ.Decorators.decorators(decoratorType));
        default:
            return Shows.Query.lenses.decorators.set(CQ.Decorators.decorators("isFavorite"));
    }
};
const PageQueryWithPagination = (pagesize, pageNumber) => {
    return Shows.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.Index.SIZE, pagesize), CQ.Page.page(CQ.Page.Index.NUMBER, pageNumber)));
};
const PageQueryWithPageSize = (pagesize) => {
    return Shows.Query.lenses.page.set(CQ.Pages.pages(CQ.Page.page(CQ.Page.Index.SIZE, pagesize)));
};
const Filter = (filterParam) => {
    switch (filterParam.type) {
        case "filterType1":
            return Videos.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filter(filterParam.filterParamtype1, filterParam.filterParamValue1)));
        case "filterType2":
            return Videos.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filter(filterParam.filterParamtype1, filterParam.filterParamValue1), CQ.Filter.filter(filterParam.filterParamtype2, filterParam.filterParamValue2)));
        default:
            return Videos.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filter("videoType", filterParam.filterParamValue1)));
    }
};
const SetQuery = (searchQuery) => {
    return Videos.Query.lenses.query.set({
        key: "query",
        value: searchQuery,
    });
};
const Sort = (sortParam) => {
    return Videos.Query.lenses.sort.set(CQ.Sort.sort(Q.QS.sortQueryValue(sortParam.key, Q.QS.Direction.ASCENDING)));
};
const FilterShow = () => {
    return Shows.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filterBoolean("isFavorite", true)));
};
const QUERY_INCLUDE_VIDEO = Videos.Query.lenses.include.set(CQ.Include.include("images", "contentPackages", "show", "genres", "primaryChannel", "taxonomyNodes"));
const QUERY_INCLUDE_SHOW = Shows.Query.lenses.include.set(CQ.Include.include("images", "contentPackages", "taxonomyNodes"));
export const getVideosEndpointWithSearchQuery = (decorator, filterParam, pageSize, pageNumber, searchQuery) => {
    return Videos.Endpoints.getVideos(compose(SetQuery(searchQuery), DecoratorForVideos(decorator), Filter(filterParam), PageQueryForVideos(pageSize, pageNumber), QUERY_INCLUDE_VIDEO)(Videos.Query.parameters));
};
export const getVideosEndpointWithSortParams = (decorator, filterParam, pageSize, pageNumber, sortParams) => {
    return Videos.Endpoints.getVideos(compose(DecoratorForVideos(decorator), Filter(filterParam), PageQueryForVideos(pageSize, pageNumber), QUERY_INCLUDE_VIDEO, Sort(sortParams))(Videos.Query.parameters));
};
export const getVideosEndpointDefault = (decorator, filterParam, pageSize, pageNumber) => {
    return Videos.Endpoints.getVideos(compose(DecoratorForVideos(decorator), Filter(filterParam), PageQueryForVideos(pageSize, pageNumber), QUERY_INCLUDE_VIDEO)(Videos.Query.parameters));
};
export const getShowsEndpointWithSearchQuery = (searchQuery, decoratorParam, pageSize, pageNumber) => {
    return Shows.Endpoints.getShows(compose(Shows.Query.lenses.query.set({
        key: "query",
        value: searchQuery,
    }), DecoratorForShows(decoratorParam), QUERY_INCLUDE_SHOW, PageQueryWithPagination(pageSize, pageNumber))(Shows.Query.parameters));
};
export const getShowsEndpointWithFilter = (decoratorParam, pageSize, pageNumber) => {
    return Shows.Endpoints.getShows(compose(DecoratorForShows(decoratorParam), QUERY_INCLUDE_SHOW, PageQueryWithPagination(pageSize, pageNumber), FilterShow())(Shows.Query.parameters));
};
export const getShowsEndpointDefault = (searchQuery, decoratorParam, pageSize) => {
    return Shows.Endpoints.getShows(compose(Shows.Query.lenses.query.set({
        key: "query",
        value: searchQuery,
    }), DecoratorForShows(decoratorParam), QUERY_INCLUDE_SHOW, PageQueryWithPageSize(pageSize))(Shows.Query.parameters));
};
export const getShowsEndpointForSearchDefault = (searchQuery, decoratorParam, pageSize, pageNumber) => {
    return Shows.Endpoints.getShows(compose(Shows.Query.lenses.query.set({
        key: "query",
        value: searchQuery,
    }), DecoratorForShows(decoratorParam), QUERY_INCLUDE_SHOW, PageQueryWithPagination(pageSize, pageNumber))(Shows.Query.parameters));
};

